import isConfirmedServerTx from './is-confirmed-server-tx.js'

// Fetches JSON transaction history from the given Ethereum server
// object (from @exodus/ethereum-api). Starts fetching from the given
// block cursor and returns the latest cursor and all transactions
// fetched in the process. minimumConfirmations determines how many
// confirmations a transaction must have for the cursor to be moved
// to that transaction's block.

export default async function getHistoryFromServer({
  server,
  ourWalletAddress,
  index,
  minimumConfirmations,
  limit = 1000,
}) {
  if (limit === 0) return []
  const allTransactionsFromServer = []

  let isEndOfAddressHistory = false
  let newIndex = index
  while (true) {
    const transactions = await server.getHistoryV2(ourWalletAddress, {
      index,
      limit, // the server returns the number of TXs that's less or equal to the limit
    })

    if (transactions.length === 0) isEndOfAddressHistory = true
    for (const transaction of transactions) {
      allTransactionsFromServer.push(transaction)
      index = transaction.addressIndex + 1 // this index is used to fetch a next page of TXs
      if (transaction.confirmations >= minimumConfirmations) newIndex = transaction.addressIndex + 1 // this index is used to return from the function
      if (!isConfirmedServerTx(transaction)) isEndOfAddressHistory = true
    }

    if (isEndOfAddressHistory) {
      return {
        allTransactionsFromServer,
        index: newIndex,
      }
    }
  }
}
